export const EntityName = {
  AccountEntity: 'Account',
  AdGroupEntity: 'AdGroup',
  AdEntity: 'Ad',
  AuctionInsightEntity: 'AuctionInsight',
  AudiencesAssociationEntity: 'AdGroupAudienceAssociation',
  AssetGroupEntity: 'AssetGroup',
  CampaignEntity: 'Campaign',
  KeywordEntity: 'Keyword',
  SearchTermEntity: 'SearchTerm',
  DsaTargetEntity: 'DsaTarget',
  PortfolioBidStrategyEntity: 'PortfolioBidStrategy',
};

export const EdmEntityName = {
  AccountEdmEntity: 'Accounts',
  AdEdmEntity: 'Ads',
  AdGroupEdmEntity: 'AdGroups',
  AdGroupCriterionEdmEntity: 'AdGroupCriterions',
  AssetGroupEdmEntity: 'AssetGroups',
  CampaignEdmEntity: 'Campaigns',
  CampaignCriterionEdmEntity: 'CampaignCriterions',
  KeywordEdmEntity: 'Keywords',
  AudienceCriterionWithBIEdmEntity: 'AudienceCriterionWithBIs',
  DsaTargetEdmEntity: 'DsaTargets',
  PortfolioBidStrategyEdmEntity: 'PortfolioBidStrategies',
};

// For entities like DsaTarget, they should escape the logic of quering
// on their parent entities even if no filter is applied
export const PersistentEntity = [
  EntityName.DsaTargetEntity,
  EntityName.PortfolioBidStrategyEntity,
  // Accounts Summary should always query on the Account entity, regardless of filter.
  EntityName.AccountEntity,
];
